import { Chip } from '@keplerco/core';
import React from 'react';
import { AssessmentStatus } from '../../enums/assessment-status';

export function AssessmentStatusChip({ assessmentStatus }: { assessmentStatus: AssessmentStatus | undefined }): React.ReactElement {
  if (assessmentStatus === AssessmentStatus.Draft) {
    return <Chip customTheme={{ backgroundColor: 'background', borderColor: 'borders', color: 'text' }}>Draft</Chip>;
  }
  if (assessmentStatus === AssessmentStatus.Active) {
    return <Chip themeColour="a">Active</Chip>;
  }
  if (assessmentStatus === AssessmentStatus.Closed) {
    return <Chip themeColour="g">Closed</Chip>;
  }
  if (assessmentStatus === AssessmentStatus.Archived) {
    return <Chip>Archived</Chip>;
  }
  if (assessmentStatus === AssessmentStatus.Scheduled) {
    return <Chip customTheme={{ backgroundColor: 'background', borderColor: 'blue', color: 'text' }}>Scheduled</Chip>;
  }

  return <Chip customTheme={{ backgroundColor: 'background', borderColor: 'borders', color: 'text' }}>Draft</Chip>;
}

